<div class="d-flex justify-content-center mt-5">
  <div class="card text-center">
    <div class="card-block">
      <h4 class="h4 card-title" i18n>Access Denied.</h4>
      <p class="default-paragraph card-text" i18n>The page you were trying to reach is forbidden.</p>
      <a [routerLink]="['/', 'home']" class="btn btn-primary">Click here to go to home</a>
    </div>
  </div>
</div>
